import React, {useState, useContext} from 'react';
import './AsideMenu.css'
import config from '../../config';
import { Link } from 'react-router-dom';
import { AppsIcon, UsersIcon, UsersTriIcon, UploadIcon } from '../../assets/icons/icons';
import { AppAuthGlobalVariables } from '../../contexts/AppAuthContext';
import {ReactComponent as SysCubeLogo}  from '../../assets/svgs/systrategy_cube_logo.svg';
import {ReactComponent as SysWordLogo}  from '../../assets/svgs/systrategy_word_logo.svg';
import {ReactComponent as CondeNastLogo}  from '../../assets/svgs/condenast.svg';
import Divider from '@mui/material/Divider';
import Import from '../../routes/application/import/Import';

function AsideMenu(props) {

    const alwaysOpen = !!props.alwaysOpen || false
    const [ sideHover, setSideHover ] = useState(!props.alwaysOpen ? false : true);
    const [ selectedPage, setSelectedPage ] = useState(config.HOME_PAGE);
    const {privs} = useContext(AppAuthGlobalVariables);

    const handleHover = (action) => {
        if (action === 'in') {
            setSideHover(true);
        } else {
            setSideHover(false);
        }
    }

    return (
        <aside className={!alwaysOpen ? '' : 'alwaysOpen'} onMouseEnter={() => {if(!alwaysOpen)handleHover('in')}} onMouseLeave={() => {if(!alwaysOpen)handleHover('out')}}>
            <div className="logo-and-menu-container">
                <div className={`side-menu-logo ${config.ENV === 'Prod' ? '' : `notprodenv-logo-${config.ENV}`}`}>
                    <CondeNastLogo className="logoImage"/>
                </div>
                <ul>
                    <li>
                        <Link to={config.HOME_PAGE} className="linkMenu" onClick={() => setSelectedPage('dashboard')}>
                            <div className={`side-menu-options ${selectedPage==='dashboard' ? 'last-voice-selected' : ''}`}>
                                <AppsIcon/>
                                {sideHover && <div>Your Applications</div>}
                            </div>
                        </Link>
                    </li>

                    {(props.userIsAdmin || !(
                        privs.P_ADBOOK              < 'R' &&
                        privs.P_WORKDAY             < 'R' &&
                        privs.P_SF_PORTFOLIO        < 'R' &&
                        privs.P_ANAGRAFICHE_CLI_AGE < 'R' &&
                        privs.P_PROGRAMMATIC_PG     < 'R' &&
                        privs.P_PROGRAMMATIC_PP     < 'R' &&
                        privs.P_MANUAL_ADJUSTMENTS  < 'R')) &&
                        (<><li> 
                            <Divider component="li" />
                        </li>

                        <li>
                            <Link to={'/import'} className="linkMenu" onClick={() => setSelectedPage('import')}>
                                <div className={`side-menu-options ${selectedPage==='import' ? 'last-voice-selected' : ''}`}>
                                    <UploadIcon/>
                                    {sideHover && <div>Import & Update</div>}
                                </div>
                            </Link>
                        </li></>
                    )}
                    
                    {props.userIsAdmin&&(
                        <>
                            <li> 
                                <Divider component="li" />
                            </li>

                            <li>
                                <Link to={'/users/list'} className="linkMenu" onClick={() => setSelectedPage('users/list')}>
                                    <div className={`side-menu-options ${window.location.href.indexOf('/users/list') >= 0 || window.location.href.indexOf('/users/account-details/') >= 0 ? 'last-voice-selected' : ''}`}>
                                        <UsersIcon/>
                                        {sideHover && <div>Users</div>}
                                    </div>
                                </Link>
                            </li>

                            <li>
                                <Link to={'/users/roles'} className="linkMenu" onClick={() => setSelectedPage('/users/roles')}>
                                    <div className={`side-menu-options ${window.location.href.indexOf('/users/roles') >= 0 ? 'last-voice-selected' : ''}`}>
                                        <UsersTriIcon/>
                                        {sideHover && <div>Roles</div>}
                                    </div>
                                </Link>
                            </li>

                        </>
                    )}
                </ul>
            </div>
            <a href='https://www.systrategy.it/' target='_blank' rel="noreferrer" className="logo-container roobeekPath">
                <div style={{width: '15%'}}><SysCubeLogo style={{ paddingLeft:'10px'}}/></div>
                <div className='logo-wrapper' style={{width: '50%' }}>{sideHover && (<SysWordLogo/>)}</div>
            </a>
        </aside>
    )
}

export default AsideMenu